var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "activityproduct_div"
  }, [_c("a-card", {
    staticClass: "first_class",
    staticStyle: {
      "margin-top": "24px",
      flex: "1"
    },
    attrs: {
      bordered: false
    }
  }, [_c("a-alert", {
    attrs: {
      message: _vm.$t("activity.tips"),
      description: _vm.$t("activity.tipsContent2"),
      type: "warning",
      "show-icon": "",
      closable: ""
    }
  }), _c("br"), _c("div", {
    staticClass: "product_div"
  }, [!_vm.lookinfo ? _c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "flex-end",
      "align-items": "center",
      "margin-bottom": "20px"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      icon: "plus"
    },
    on: {
      click: function click($event) {
        return _vm.addDyx();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.add")) + " ")])], 1)]) : _vm._e(), _vm.lookinfo ? _c("a-table", {
    ref: "productList",
    attrs: {
      rowKey: "erpCustomerId",
      pagination: {
        pageSizeOptions: ["5", "10", "20", "30"],
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: function showTotal(total, range) {
          return "".concat(_vm.$t("public.total"), "\uFF1A") + _vm.listTotal;
        },
        current: _vm.queryParam.page,
        pageSize: _vm.queryParam.size,
        total: _vm.listTotal
      },
      columns: _vm.columns2,
      loading: _vm.isTableLoading,
      "data-source": _vm.dyxList
    },
    on: {
      change: _vm.tableChange
    },
    scopedSlots: _vm._u([{
      key: "goodsName",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("span", [_c("a-tooltip", [record.erpCustomerStatus == 1 ? _c("router-link", {
          staticClass: "underline",
          attrs: {
            target: "_blank",
            to: {
              path: "/customermanager/editcustomer2",
              query: {
                erpCustomerId: record.erpCustomerId
              }
            }
          }
        }, [_vm._v(" " + _vm._s(record.erpCustomerName) + " ")]) : _c("span", [_vm._v(_vm._s(record.erpCustomerName))])], 1)], 1)]);
      }
    }, {
      key: "status",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a-tag", {
          attrs: {
            color: record.erpCustomerStatus == 1 ? "blue" : "red"
          }
        }, [_vm._v(_vm._s(record.erpCustomerStatus == 2 ? _vm.$t("publicuse.delete") : record.erpCustomerStatus == 1 ? _vm.$t("public.normal") : _vm.$t("overSell2")))])], 1);
      }
    }], null, false, 941522180)
  }) : _c("a-table", {
    ref: "productList",
    attrs: {
      "row-selection": {
        onSelectAll: _vm.onSelectAll,
        onSelect: _vm.onSelect,
        onChange: _vm.onChange,
        selectedRowKeys: _vm.selectedRowKeys,
        hideDefaultSelections: true
      },
      rowKey: "erpCustomerId",
      pagination: {
        pageSizeOptions: ["5", "10", "20", "30"],
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: function showTotal(total, range) {
          return "".concat(_vm.$t("public.total"), "\uFF1A") + _vm.listTotal;
        },
        current: _vm.queryParam.page,
        pageSize: _vm.queryParam.size,
        total: _vm.listTotal
      },
      columns: _vm.columns1,
      loading: _vm.isTableLoading,
      "data-source": _vm.dyxList
    },
    on: {
      change: _vm.tableChange
    },
    scopedSlots: _vm._u([{
      key: "goodsName",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("span", [_c("a-tooltip", [record.erpCustomerStatus == 1 ? _c("router-link", {
          staticClass: "underline",
          attrs: {
            target: "_blank",
            to: {
              path: "/customermanager/editcustomer2",
              query: {
                erpCustomerId: record.erpCustomerId
              }
            }
          }
        }, [_vm._v(" " + _vm._s(record.erpCustomerName) + " ")]) : _c("span", [_vm._v(_vm._s(record.erpCustomerName))])], 1)], 1)]);
      }
    }, {
      key: "status",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a-tag", {
          attrs: {
            color: record.erpCustomerStatus == 1 ? "blue" : "red"
          }
        }, [_vm._v(_vm._s(record.erpCustomerStatus == 2 ? _vm.$t("publicuse.delete") : record.erpCustomerStatus == 1 ? _vm.$t("public.normal") : _vm.$t("overSell2")))])], 1);
      }
    }, {
      key: "action",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a-popconfirm", {
          attrs: {
            title: _vm.$t("publicuse.suerdelete"),
            "ok-text": _vm.$t("publicuse.yes"),
            "cancel-text": _vm.$t("publicuse.no")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.deleteDyx(record);
            },
            cancel: _vm.cancelDelete
          }
        }, [_c("a", {
          attrs: {
            href: "javascript:;"
          }
        }, [_vm._v(_vm._s(_vm.$t("publicuse.delete")))])])], 1);
      }
    }])
  }), !_vm.lookinfo ? _c("div", {
    staticStyle: {
      "margin-top": "-50px"
    }
  }, [_c("span", {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.selected")) + _vm._s(_vm.selectNumber) + _vm._s(_vm.$t("public.term")))]), _c("span", {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.batchoperation")))]), _c("a-button", {
    attrs: {
      type: "danger"
    },
    on: {
      click: function click($event) {
        return _vm.removeClick();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.delete")))])], 1) : _vm._e()], 1)], 1), !_vm.lookinfo ? _c("footer-tool-bar", [!_vm.activityId ? _c("a-button", {
    staticStyle: {
      "margin-right": "16px"
    },
    on: {
      click: _vm.prevStep
    }
  }, [_vm._v(_vm._s(_vm.$t("public.previousstep")))]) : _vm._e(), _c("a-button", {
    staticStyle: {
      "margin-left": "16px"
    },
    attrs: {
      loading: _vm.updateLoading,
      type: "primary"
    },
    on: {
      click: _vm.saveActivity
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("publicuse.save")) + " ")])], 1) : _vm._e(), _c("a-modal", {
    attrs: {
      width: "430px",
      title: _vm.$t("batchDelete"),
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.removeTypeVisible,
      callback: function callback($$v) {
        _vm.removeTypeVisible = $$v;
      },
      expression: "removeTypeVisible"
    }
  }, [_c("a-form-model", {
    ref: "ruleRemoveForm",
    attrs: {
      model: _vm.modalValue
    }
  }, [_c("a-form-model-item", [_c("a-radio-group", {
    model: {
      value: _vm.modalValue.removeType,
      callback: function callback($$v) {
        _vm.$set(_vm.modalValue, "removeType", $$v);
      },
      expression: "modalValue.removeType"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("activity.selectDyx")) + " ")]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.currentpage")) + " ")]), _c("a-radio", {
    attrs: {
      value: 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.allpage")) + " ")])], 1)], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        return _vm.resetFormDate();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.cancel")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.removeModal();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.determine")) + " ")])], 1)], 2), _c("selectDyx", {
    ref: "selectModal",
    attrs: {
      alreadySelect: _vm.alreadySelect
    },
    on: {
      confirmProduct: _vm.confirmProduct
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };